module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new-desktop/0027.jpg?v=dd601479";